import { Keyboard } from "@capacitor/keyboard";
import { isCapacitorPlatform } from "@src/appV2/lib/utils/capacitor/platformUtils";
import { useEffect, useState } from "react";

const useKeyboardState = () => {
  const [isKeyboardOpen, setIsKeyBoardOpen] = useState<boolean>(false);

  useEffect(() => {
    if (isCapacitorPlatform()) {
      Keyboard.addListener("keyboardWillShow", () => {
        setIsKeyBoardOpen(true);
      });
      Keyboard.addListener("keyboardDidHide", () => {
        setIsKeyBoardOpen(false);
      });
    }

    return () => {
      if (isCapacitorPlatform()) {
        Keyboard.removeAllListeners();
      }
    };
  }, []);

  return { isKeyboardOpen };
};

export { useKeyboardState };
